import { render, staticRenderFns } from "./ModalUtm.vue?vue&type=template&id=3bda66a8"
import script from "./ModalUtm.vue?vue&type=script&lang=js"
export * from "./ModalUtm.vue?vue&type=script&lang=js"
import style0 from "./ModalUtm.vue?vue&type=style&index=0&id=3bda66a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports